import React, { useState } from 'react';
import { validationAPI } from '../services/api';

const Validator = () => {
    const [domain, setDomain] = useState('');
    const [recordType, setRecordType] = useState('A');
    const [nsResult, setNsResult] = useState(null);
    const [dnsResult, setDnsResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleCheckNameservers = async (e) => {
        e.preventDefault();
        if (!domain) return;

        try {
            setLoading(true);
            const response = await validationAPI.checkNameservers(domain);
            setNsResult(response.data);
        } catch (error) {
            setNsResult({ error: error.message });
        } finally {
            setLoading(false);
        }
    };

    const handleCheckDNS = async (e) => {
        e.preventDefault();
        if (!domain) return;

        try {
            setLoading(true);
            const response = await validationAPI.checkDNS(domain, recordType);
            setDnsResult(response.data);
        } catch (error) {
            setDnsResult({ error: error.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h2 className="card-title">🔍 Validador DNS</h2>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
                    {/* Nameservers Checker */}
                    <div>
                        <h3 style={{ marginBottom: '1rem', color: '#374151' }}>
                            Validar Nameservers
                        </h3>
                        <form onSubmit={handleCheckNameservers}>
                            <div className="form-group">
                                <label className="form-label">Domínio</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder="exemplo.com.br"
                                    value={domain}
                                    onChange={(e) => setDomain(e.target.value)}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                                style={{ width: '100%' }}
                            >
                                {loading ? '⏳ Verificando...' : '🔍 Verificar Nameservers'}
                            </button>
                        </form>

                        {nsResult && (
                            <div style={{ marginTop: '1.5rem' }}>
                                {nsResult.error ? (
                                    <div className="error">
                                        ❌ Erro: {nsResult.error}
                                    </div>
                                ) : (
                                    <div>
                                        <div className={nsResult.configured ? 'success-message' : 'error'}>
                                            {nsResult.configured ? (
                                                <>
                                                    <strong>✅ Nameservers Configurados Corretamente!</strong>
                                                    <div style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
                                                        Status da zona: <span className="badge success">{nsResult.status}</span>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <strong>❌ Nameservers NÃO Configurados!</strong>
                                                    <div style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
                                                        Status da zona: <span className="badge pending">{nsResult.status}</span>
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div style={{ marginTop: '1rem' }}>
                                            <div style={{ marginBottom: '1rem' }}>
                                                <strong style={{ color: '#374151', display: 'block', marginBottom: '0.5rem' }}>
                                                    Nameservers Esperados (Cloudflare):
                                                </strong>
                                                <ul className="nameservers-list">
                                                    {nsResult.expected.map((ns, idx) => (
                                                        <li key={idx} style={{ background: '#d1fae5', color: '#065f46' }}>
                                                            {ns}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div>
                                                <strong style={{ color: '#374151', display: 'block', marginBottom: '0.5rem' }}>
                                                    Nameservers Atuais (DNS Público):
                                                </strong>
                                                {nsResult.actual.length > 0 ? (
                                                    <ul className="nameservers-list">
                                                        {nsResult.actual.map((ns, idx) => (
                                                            <li key={idx} style={{
                                                                background: nsResult.configured ? '#d1fae5' : '#fee2e2',
                                                                color: nsResult.configured ? '#065f46' : '#991b1b'
                                                            }}>
                                                                {ns}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <div className="error">
                                                        Nenhum nameserver encontrado
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* DNS Resolution Checker */}
                    <div>
                        <h3 style={{ marginBottom: '1rem', color: '#374151' }}>
                            Validar Resolução DNS
                        </h3>
                        <form onSubmit={handleCheckDNS}>
                            <div className="form-group">
                                <label className="form-label">Domínio/Subdomínio</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder="www.exemplo.com.br"
                                    value={domain}
                                    onChange={(e) => setDomain(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Tipo de Registro</label>
                                <select
                                    className="form-select"
                                    value={recordType}
                                    onChange={(e) => setRecordType(e.target.value)}
                                >
                                    <option value="A">A (IPv4)</option>
                                    <option value="AAAA">AAAA (IPv6)</option>
                                    <option value="CNAME">CNAME</option>
                                    <option value="MX">MX (Email)</option>
                                    <option value="TXT">TXT</option>
                                    <option value="NS">NS (Nameserver)</option>
                                </select>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={loading}
                                style={{ width: '100%' }}
                            >
                                {loading ? '⏳ Consultando...' : '🔍 Consultar DNS'}
                            </button>
                        </form>

                        {dnsResult && (
                            <div style={{ marginTop: '1.5rem' }}>
                                {dnsResult.error ? (
                                    <div className="error">
                                        ❌ Erro: {dnsResult.error}
                                    </div>
                                ) : (
                                    <div>
                                        <div className={dnsResult.resolves ? 'success-message' : 'error'}>
                                            {dnsResult.resolves ? (
                                                <>
                                                    <strong>✅ Registro Encontrado!</strong>
                                                    <div style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
                                                        Tipo: <code>{dnsResult.type}</code>
                                                    </div>
                                                </>
                                            ) : (
                                                <strong>❌ Nenhum Registro Encontrado</strong>
                                            )}
                                        </div>

                                        {dnsResult.result.length > 0 && (
                                            <div style={{ marginTop: '1rem' }}>
                                                <strong style={{ color: '#374151', display: 'block', marginBottom: '0.5rem' }}>
                                                    Resultado:
                                                </strong>
                                                <div className="code-block">
                                                    <code>
                                                        {dnsResult.result.map((line, idx) => (
                                                            <div key={idx}>{line}</div>
                                                        ))}
                                                    </code>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="card" style={{ background: '#f0f9ff', borderLeft: '4px solid #0284c7' }}>
                <h3 style={{ color: '#0c4a6e', marginBottom: '1rem' }}>
                    ℹ️ Como Usar
                </h3>
                <div style={{ color: '#0c4a6e', lineHeight: '1.6' }}>
                    <p><strong>Validar Nameservers:</strong> Verifica se os nameservers do domínio estão configurados corretamente para a Cloudflare.</p>
                    <p style={{ marginTop: '0.5rem' }}><strong>Validar Resolução DNS:</strong> Consulta os registros DNS públicos para verificar se um domínio/subdomínio está resolvendo corretamente.</p>
                    <p style={{ marginTop: '0.5rem' }}><strong>Dica:</strong> Use a validação de nameservers primeiro para garantir que o domínio está apontando para a Cloudflare antes de validar registros específicos.</p>
                </div>
            </div>
        </div>
    );
};

export default Validator;
